module.exports = __webpack_public_path__ + "static/media/screen8.09b259a6.png";